import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gympie")({
  beforeLoad: () => {
    throw redirect({ href: "/conveyancing", statusCode: 301 });
  },
});
